import * as React from 'react';
import classnames from 'classnames';

const Hr = ({ className  })=>/*#__PURE__*/ React.createElement("hr", {
        className: classnames('horizontal-rule', className)
    })
;

export { Hr as default };
//# sourceMappingURL=Hr.js.map
